import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, StateUtils, submissionViewModel, CoveragesUtil, CoverageService) {
    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();

    ctrl.init = function () {
        $scope.questionSets = submissionVM.lobData.businessOwners.preQualQuestionSets.value;
        // QnB flow creates submission after Wizard entry, calling dependent coverage map here ensures a quoteID
        CoveragesUtil.getDependentCoveragesForLOB(CoverageService, submissionVM.quoteID.value);
    };

    ctrl.next = function (nextFn, form) {
        // prequal question requiredness not captured in the submission model, so pass form validity for isValid check
        nextFn(submissionVM, { valid: form.valid });
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils', 'submissionViewModel', 'CoveragesUtil', 'CoverageService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/bop/controllers/BOPPrequalQuestionsCtrl.js
// module id = 2108
// module chunks = 0